import styled, { css } from 'styled-components'
import { SecondaryButton } from '../../../shared/Buttons/Buttons.styles'

export const ArticleContainer = styled.div`
  display: block;
  margin-bottom: 8rem;

  & > div:first-child {
    border-top: 0;
    padding-top: 0;
    margin-top: 4.8rem;
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    margin-bottom: 12rem;

    & > div:first-child {
      border-top: 1px solid ${props => props.theme.colors.black};
      padding-top: 2rem;
      margin-top: 0rem;
    }
  }
`

export const Error = styled.p`
  border-top: 1px solid ${props => props.theme.colors.black};
  padding-top: 2rem;
  font-size: 1.8rem;
  margin-top: 3.2rem;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    margin-top: 0;
  }
`

export const ArticleFilterContainer = styled.div`
  display: flex;
  flex-flow: column;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
  margin-top: 1.5rem;

  ${props => props.open && css`
    overflow: visible;
    height: auto;
    max-height: 100rem;
    transition: max-height 1s ease-in-out;
  `};

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    flex-flow: row nowrap;
    /* To accomodate for the extra spacing due to the arrows */
    margin-top: 14.1rem;
    max-height: none;
    overflow: auto;
    transition: none;
  }
`

export const ArticleFilterTrigger = styled.div`
  position: relative;
  margin-top: 4.1rem;
  font-size: 1.6rem;
  line-height: 1.75;
  padding: 1rem 0;
  border-bottom: 1px solid ${props => props.theme.colors.black};
  text-align: left;

  svg {
    position: absolute;
    top: 2.1rem;
    right: 0;
    width: 18px;
    height: 8px;
    transform: rotate(180deg);
    transition: all 0.3s;

    ${props => props.open && css`
      transform: rotate(0deg);
    `};
  }

  ${props => props.open && css`
    margin-bottom: 0;
  `};

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    display: none;
  }
`

export const ButtonContainer = styled.div`
  text-align: center;
  margin-top: 2rem;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    display: none;
  }
`

export const ArticleFilterButton = styled(SecondaryButton)`
  display: inline-block;

  &:first-child {
    margin-right: 2rem;
  }

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    display: none;
  }
`
